import { qualifyUrls } from "routing/Routes";
const AIManagementRoutes = {
  MODEL_PROVIDERS: "/ai-management/model-providers",
  FEATURE_MODELS: "/ai-management/feature-models",
  MODEL_PROVIDER_CREATE: "/ai-management/model-providers/new",
  modelProviderEdit: (providerId) => `/ai-management/model-providers/${providerId}/edit`,
  TOKEN_USAGE: "/ai-management/token-usage"
};
const routes = qualifyUrls(AIManagementRoutes);
export default {
  ...routes,
  unqualified: AIManagementRoutes
};
